import PropTypes from 'prop-types'
import React from 'react'
import EditAddressComponent from 'components/IncomingEmails/EditAddress'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'

export class EditAddress extends React.Component {
  static propTypes = {
    cardId: PropTypes.number.isRequired,

    name: PropTypes.array.isRequired,

    incomingMailsDomain: PropTypes.string.isRequired,
    cardTemplateId: PropTypes.number,
    validateAddress: PropTypes.bool.isRequired,

    requestChangeIncomingMail: PropTypes.func.isRequired
  }

  handleEditAddress = ({ name, validateAddress }) => {
    return this.props.requestChangeIncomingMail({
      cardId: this.props.cardId,
      name,
      validateAddress,
    })
  }

  render () {
    const {
      name,
      incomingMailsDomain,
      cardTemplateId,
      validateAddress
    } = this.props

    return (
      <CardModalView
        title={name + '@' + incomingMailsDomain}
      >
        <ViewBody>
          <EditAddressComponent
            name={name}
            cardTemplateId={cardTemplateId}
            validateAddress={validateAddress}
            onEditAddress={this.handleEditAddress}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default EditAddress
